export default __webpack_public_path__ + "d922cdd6efd50e4e38d5b2a7497c8b3e.svg";